export default function useSaleLabel(product: any) {
    const { snippets } = useSnippetsStore();
    const settings = inject('siteSettings', []);

    const saleLabel = computed(() => {
        const showPercentage = settings?.[0]?.showSalePercentage || false;
        if (showPercentage) {
            const percentage = product?.calculatedPrice?.listPrice?.percentage;
            if (percentage) {
                // Format as "XX%" (e.g., "20%") without decimals
                return `${Math.round(Math.abs(percentage))}%`;
            }
        }

        return snippets['headless.product.saleBadge'] || 'SALE'; // Fallback to default snippet
    });

    const productIsOnSale = computed(() => {
        const listPrice = product?.calculatedPrice?.listPrice?.price;
        const actualPrice = product?.calculatedPrice?.totalPrice;

        return listPrice && actualPrice && listPrice > actualPrice;
    });

    return {
        productIsOnSale,
        saleLabel,
    };
}
